import { render, staticRenderFns } from "./plansSelection.vue?vue&type=template&id=e528f728&"
import script from "./plansSelection.vue?vue&type=script&lang=ts&"
export * from "./plansSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports